import { useEffect } from "react";
import { useFeatureFlag } from "../../hooks/globalSettingsHooks";
import { ADABOT_BINDER_PORTAL } from "../../constants/featureFlags";
import {
  FORETHOUGHT_API_KEY,
  FORETHOUGHT_SCRIPT_URL,
  FORETHOUGHT_SCRIPT_ID,
} from "../../constants/forethought";

function ForethoughtChatbot() {
  const forethoughtEnabled = useFeatureFlag(ADABOT_BINDER_PORTAL);

  useEffect(() => {
    if (!forethoughtEnabled) return;
    const existingScript = document.getElementById(FORETHOUGHT_SCRIPT_ID);
    if (!existingScript) {
      const script = document.createElement("script");
      script.src = FORETHOUGHT_SCRIPT_URL;
      script.id = FORETHOUGHT_SCRIPT_ID;
      script.setAttribute("data-api-key", FORETHOUGHT_API_KEY);
      document.body.appendChild(script);
    }
  }, [forethoughtEnabled]);

  return null;
}

export const openForethoughtWidget = (): void => {
  if (typeof window.Forethought === "function") {
    window.Forethought("widget", "open");
  } else {
    console.warn("Forethought widget not loaded");
  }
};

export const updateForethoughtContext = (
  context: Record<string, string>
): void => {
  if (typeof window.Forethought === "function") {
    window.Forethought("widget", "updateConversationContext", context);
  } else {
    console.warn("Forethought widget not loaded");
  }
};

export default ForethoughtChatbot;
